module.exports = __webpack_public_path__ + "media/click-error-1110.7195ed31.wav";